// Orange
export const orange = '#F37E60'

// Blues
export const lightBlue = '#EAEDEF'
export const mediumBlue = '#94ACBF'
export const darkBlue = '#314C63'
export const darkerBlue = '#233A4E'
